import { recruiterTransportPolicy } from './appTransportPolicies';
import type { AppTransportPolicy } from './transportTypes';

// Direct consumers outside index.tsx retain the existing behavior. Production
// entries select their app explicitly before starting any bootstrap request.
let selectedPolicy: AppTransportPolicy = recruiterTransportPolicy;

export function configureAppTransport(policy: AppTransportPolicy): void {
  selectedPolicy = policy;
}

export function getAppTransport(): AppTransportPolicy {
  return selectedPolicy;
}

declare module 'axios' {
  interface AxiosRequestConfig {
    /** The preparing app also owns retries and failures after navigation. */
    appTransportPolicy?: AppTransportPolicy;
  }
}
